import repositories from '..';

const resource = '/system/logs';

export default {
  getInitData: () => repositories.get(`${resource}/data/init`),
  getMailLog: () => repositories.get(`${resource}/mail`),
  resendEmail: (data: any) => repositories.post(`${resource}/mail/${data.id}`),
};
